export default __webpack_public_path__ + "static/equilibre_illustration_landing-d438f47f9123e7a42e73fd93b78e23d6.png";